import React, { useEffect } from "react";

export default function SoundopeVs() {
  useEffect(() => {
    const title =
      "Soundope vs SubmitHub vs Playlist Push vs Groover vs SoundCampaign 2025";
    document.title = title;

    const description =
      "2025 side-by-side comparison: Soundope vs SubmitHub vs Playlist Push vs Groover vs SoundCampaign. See prices, minimum buys, bots, and who guarantees real feedback on every track.";

    const metaTags = [
      { type: "name", key: "description", content: description },
      {
        type: "name",
        key: "keywords",
        content:
          "soundope vs submithub, soundope vs playlist push, soundope vs groover, soundope vs soundcampaign, playlist platform comparison 2025",
      },
      { type: "name", key: "robots", content: "index, follow" },

      // Open Graph
      { type: "property", key: "og:title", content: title },
      { type: "property", key: "og:description", content: description },
      { type: "property", key: "og:type", content: "website" },
      { type: "property", key: "og:url", content: window.location.href },

      // Twitter
      { type: "name", key: "twitter:card", content: "summary_large_image" },
      { type: "name", key: "twitter:title", content: title },
      { type: "name", key: "twitter:description", content: description },

      // Canonical
      {
        type: "link",
        key: "canonical",
        content: window.location.origin + "/vs",
      },
    ];

    metaTags.forEach(({ type, key, content }) => {
      if (type === "link") {
        let tag = document.querySelector(`link[rel="${key}"]`);
        if (tag) {
          tag.setAttribute("href", content);
        } else {
          tag = document.createElement("link");
          tag.setAttribute("rel", key);
          tag.setAttribute("href", content);
          document.head.appendChild(tag);
        }
      } else {
        const selector =
          type === "property"
            ? `meta[property="${key}"]`
            : `meta[name="${key}"]`;
        let tag = document.querySelector(selector);

        if (tag) {
          tag.setAttribute("content", content);
        } else {
          tag = document.createElement("meta");
          tag.setAttribute(type, key);
          tag.setAttribute("content", content);
          document.head.appendChild(tag);
        }
      }
    });
  }, []);

  return (
    <div className="min-h-screen px-4 py-16 pb-32 bg-[#050505]">
      <div className="max-w-4xl mx-auto overflow-x-auto">
        <h1 className="text-3xl md:text-4xl font-light mb-6 text-[#f5f5f5]">
          Soundope vs Every Playlist Platform in 2025 (Price, Bots, Real
          Feedback)
        </h1>

        <p className="text-base md:text-lg text-[#bbbbbb] mb-4">
          Side-by-side truth — no marketing fluff.
        </p>

        <div className="neuro-base rounded-3xl p-4 md:p-6 bg-[#0b0b0b] border border-[#262626] mb-6 overflow-x-auto">
          <table className="w-full text-left text-sm md:text-base border-collapse min-w-[640px]">
            <thead>
              <tr className="border-b border-[#2a2a2a] text-[#d0d0d0]">
                <th className="py-3 pr-4">2025</th>
                <th className="py-3 pr-4">Price</th>
                <th className="py-3 pr-4">Min Buy</th>
                <th className="py-3 pr-4">Real Curators</th>
                <th className="py-3 pr-0">Feedback Guarantee</th>
              </tr>
            </thead>
            <tbody className="text-[#b0b0b0]">
              <tr className="border-b border-[#1a1a1a]">
                <td className="py-3 pr-4">
                  <strong>Soundope</strong>
                </td>
                <td className="py-3 pr-4">$1</td>
                <td className="py-3 pr-4">$5</td>
                <td className="py-3 pr-4">100%</td>
                <td className="py-3 pr-0">Yes</td>
              </tr>
              <tr className="border-b border-[#1a1a1a]">
                <td className="py-3 pr-4">SubmitHub</td>
                <td className="py-3 pr-4">$2–$6</td>
                <td className="py-3 pr-4">$10</td>
                <td className="py-3 pr-4">Heavy bots</td>
                <td className="py-3 pr-0">No</td>
              </tr>
              <tr className="border-b border-[#1a1a1a]">
                <td className="py-3 pr-4">Playlist Push</td>
                <td className="py-3 pr-4">$250–$1k+</td>
                <td className="py-3 pr-4">$250</td>
                <td className="py-3 pr-4">Fake streams</td>
                <td className="py-3 pr-0">No</td>
              </tr>
              <tr className="border-b border-[#1a1a1a]">
                <td className="py-3 pr-4">Groover</td>
                <td className="py-3 pr-4">$2–$3</td>
                <td className="py-3 pr-4">$20</td>
                <td className="py-3 pr-4">Growing bots</td>
                <td className="py-3 pr-0">No</td>
              </tr>
              <tr>
                <td className="py-3 pr-4">SoundCampaign</td>
                <td className="py-3 pr-4">$80–$500</td>
                <td className="py-3 pr-4">$80</td>
                <td className="py-3 pr-4">Payola exposed</td>
                <td className="py-3 pr-0">No</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="text-base md:text-lg text-[#bbbbbb] mb-4">
          Soundope is the only platform in 2025 with $5 minimum, $1 submissions,
          zero bots, and feedback on every track.
        </p>

        <a
          href="/signup"
          className="inline-block px-6 py-3 rounded-full bg-[#b61f3d] text-white text-sm md:text-base font-semibold tracking-wide hover:bg-[#e0254c] transition-colors"
        >
          Switch Now — Start Free
        </a>

        <div className="mt-4">
          <a
            href="/Upload"
            className="inline-block px-6 py-3 rounded-full bg-transparent border border-[#b61f3d] text-[#f5f5f5] text-sm md:text-base font-semibold tracking-wide hover:bg-[#b61f3d] hover:text-white transition-colors"
          >
            Upload a track now
          </a>
        </div>
      </div>
    </div>
  );
}


